import { Injectable, inject } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OverlaysService {
  private readonly ngxLoader = inject(NgxUiLoaderService);


  startLoader() {
    this.ngxLoader.start();
  }

  stopLoader() {
    this.ngxLoader.stop();
  }

  async presentAngularLoader() {
    this.ngxLoader.start();
  }

  async dismissAngularLoader() {
    this.ngxLoader.stop();
  }

  requestWithLoader(request: () => Observable<any>) {
    this.presentAngularLoader().then();
    const r = request().pipe(shareReplay());
    r.subscribe(
      () => this.dismissAngularLoader(),
      () => this.dismissAngularLoader()
    );
    return r;
  }
}
